import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { fetchVehicleSubstatusDetails } from 'store/vehicles/actions';
import VehicleSubstatusDetails from './VehicleSubstatusDetails';

export default compose(
  connect(
    (state) => ({
      responseDialog: state.vehicles.responseDialog,
      showTitle: false,
      vehicleSubstatusDetails: state.vehicles.vehicleSubstatusDetails,
    }),
    { fetchVehicleSubstatusDetails }
  )
)(VehicleSubstatusDetails);
